import { useEffect, useState } from "react";
import { readAppUpdateState, subscribeAppUpdate } from "../services/appVersionMonitor";
import { useAppModal } from "./AppModalProvider";
import { runAutoDialog } from "../services/autoDialogCoordinator";

export function AppUpdateNoticeGate() {
  const modal = useAppModal();
  const [available, setAvailable] = useState(() => readAppUpdateState().available);
  useEffect(() => subscribeAppUpdate((next) => setAvailable(next.available)), []);
  useEffect(() => {
    if (!available) return;
    let cancelled = false;
    void runAutoDialog("app-update", () => modal.confirm({ title: "发现新版本", message: "新版本资源已经可用。刷新不会删除本地存档。", confirmLabel: "安全刷新", cancelLabel: "稍后" })).then((accepted) => {
      if (!cancelled && accepted) window.location.reload();
      setAvailable(false);
    });
    return () => { cancelled = true; };
  }, [available, modal.confirm]);
  return null;
}
